import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '外部项目维度实体',
    type: 'DE_1',
}
